import Cookies from "js-cookie";
import { Outlet, useNavigate } from "react-router";

const PrivateLayout = () => {
  let Auth =
    import.meta.env.VITE_DEBUGGING === "TRUE"
      ? true
      : Cookies.get("access") || sessionStorage.getItem("access");
  const navigate = useNavigate();

  if (!Auth) return <>{navigate("/login")}</>;
  return <Outlet />;
  // return <>{Cookies.get("access") ? <Outlet /> : <Navigate to="/login" />}</>;
};

export default PrivateLayout;
